'use strict';
const Backbone = require('backbone');

const repositories = {};

class Repository {
    constructor(project) {
        this._project = project;
        this._actionWorks = new Backbone.Collection;
        this._worksByAction = {};
        this._actionsByWork = {};
        this._actionPromise = {};
        this._workPromise = {};
    }

    /**
     * ActionWork を Repository に追加する
     *
     * @param actionWork
     */
    add(actionWork) {
        const aw = this._actionWorks.add(actionWork, {merge: true});

        const action = actionWork.getAction();
        const work = actionWork.getWork();

        const works = this.getActionWorksByAction(action);
        works.add(aw, {merge: true});

        const actions = this.getActionWorksByWork(work);
        actions.add(aw, {merge: true});

        return aw;
    }

    get() {
        return this._actionWorks;
    }

    getActionWorksByActionAndId(action, actionWorkId) {
        const works = this._worksByAction[action.id];
        if(!works) {
            return ;
        }
        let actionWork;
        actionWork = works.find((aw) => {
            return aw.id === actionWorkId
        });
        return actionWork;
    }

    getActionWorksByAction(action) {
        let works = this._worksByAction[action.id];
        if(!works) {
            works = new Backbone.Collection();
            this._worksByAction[action.id] = works;
        }
        return works;
    }

    getActionWorksByWork(work) {
        let actions = this._actionsByWork[work.id];
        if(!actions) {
            actions = new Backbone.Collection();
            this._actionsByWork[work.id] = actions;
        }
        return actions;
    }

    remove(actionWork) {
        return this._actionWorks.remove(actionWork);
    }

    /**
     * ActionWork を保存する。
     */
    save() {
        throw 'Not Implemented!';
    }

    fetchActionWorksByAction(action, limit) {
        throw 'Not Implemented!';
    }

    fetchActionWorksByActionOnce(action, limit) {
        throw 'Not Implemented!';
    }

    hasNextActionWorksByAction(action) {
        throw 'Not Implemented!';
    }

    static find(project) {
        const key = project.id;
        let r = repositories[key];
        if (!r) {
            r = new Repository(project);
            repositories[key] = r;
        }
        return r;
    }
}

module.exports = Repository;



// WEBPACK FOOTER //
// ./process/domain/repository/actionwork.js